import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(
  () => import("../components/transcript/report/reportDetails/reportDetails")
);

const TranscriptReportDetails = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default TranscriptReportDetails;
